import React from 'react';
import Loading from 'react-loading';
const SubmitButton = (props) => {
    const loading = props.customLoading ? (props.customLoading) : (React.createElement(Loading, { type: "spin", height: 20, width: 20 }));
    return (React.createElement("button", Object.assign({}, props.buttonProps, { type: "submit", "data-testid": props.testId ? props.testId : 'submit-button', className: `btn ${props.className ? props.className : 'btn-primary'}`, disabled: props.isSubmitting || props.disabled, onClick: props.onClick }), props.isSubmitting ? loading : props.buttonText));
};
export default SubmitButton;
